// import moment from "moment";
import moment from "moment-timezone";
import { axiosGet } from "../../../../../../app/Helpers/AxiosHelper";
import { BASE_TASK } from "../../../../../../app/Config/ApiUrl";

import { SortedMixins } from "../../mixins/taskMixins";
import { csvParse } from "d3";

// const parseJSON = (invalidJSON) => {
//   const jsonObject = JSON.parse(invalidJSON);
//   return jsonObject.form.forEach(item => {
//     if (item.name === "number") {
//       item.value = parseInt(item.value);
//     }
//   });
// }

export class Comment {
  constructor(params) {
    this.createdAt = params.created_at;
    this.updatedAt = params.updated_at;
    this.content = params.content;
    this.content_display = params.content_display;
    this.taskID = params.task_id;
    this.reply = params.reply;
    this.reply_comments = params.reply_comments;
    this.internal = params.internal;
    this.id = params.id;
    this.user = params.user;
  }
}

export class Note {
  constructor(params) {
    this.id = params.id;
    this.content = params.attributes?.content || params.content;
    this.taskId = params.attributes?.task_id || params.task_id;
    this.taskUserId = params.attributes?.task_user_id || params.task_user_id;
    this.createdAt = params.attributes?.created_at || params.created_at;
    this.updatedAt = params.attributes?.updated_at || params.updated_at;
    this.deletedAt = params.attributes?.deleted_at || params.deleted_at;
    
    // Parse user data from relationships
    if (params.relationships && params.relationships.users && params.relationships.users.data) {
      const userData = params.relationships.users.data;
      this.user = {
        id: userData.id,
        first_name: userData.attributes?.first_name || '',
        last_name: userData.attributes?.last_name || '',
        email: userData.attributes?.email || '',
        color: userData.attributes?.color || '#8e85bb',
        avatar: userData.attributes?.chat_avatar || null,
        role: userData.attributes?.role || 'user'
      };
    } else if (params.user) {
      this.user = params.user;
    } else {
      this.user = null;
    }
    
    // Parse task data if needed
    if (params.relationships && params.relationships.tasks && params.relationships.tasks.data) {
      this.task = params.relationships.tasks.data;
    }
    
    // Format dates for display
    this.formattedDate = this.createdAt ? moment(this.createdAt).format("MMMM Do YYYY, h:mm A") : '';
    this.fromNow = this.createdAt ? moment(this.createdAt).fromNow() : '';
  }
  
  // Method to update note content
  updateContent(newContent) {
    this.content = newContent;
    this.updatedAt = new Date().toISOString();
  }
}

export class Notification {
  constructor(params) {
    this.id = params.id;
    this.has_read = params.has_read;
    this.created_at = moment(params.created_at).format("YYYY-MM-DD");
    this.updated_at = moment(params.updated_at).format("YYYY-MM-DD");
    this.time = new Date(params.created_at).toLocaleTimeString();
    this.models = params.models;
    this.object = params.object;
    this.owner = params.owner;
    this.isWritable = params.isWritable;
    this.parseOwner = `${params.owner.firstName} ${params.owner.lastName}`;

    this.message = params.message;
    this.content = params.content.message;
    this._content = params.content;

    // SLA alerts are sent by the system, not by a user: avoid an "undefined undefined" avatar.
    if (this.isSlaBreach() && !(params.owner && (params.owner.firstName || params.owner.lastName))) {
      const label = (this._content && this._content.owner) || "SLA monitor";
      this.owner = { ...(params.owner || {}), title: label, alt: label };
      this.parseOwner = label;
    }

    this.text = this.formatText();
  }

  isSlaBreach() {
    return (
      (this._content && this._content.type === "sla_breach") ||
      (this.message && this.message.activityType === "sla_breach")
    );
  }

  // Titles are rendered with v-html: escape anything coming from user/task data.
  static escapeHtml(value) {
    return String(value === null || value === undefined ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  updateNotification(property, new_value) {
    this[property] = new_value;
  }

  comment() {}

  formatText() {
    if (this.isSlaBreach()) {
      const escape = Notification.escapeHtml;
      const actions = Array.isArray(this._content.actions) ? this._content.actions : [];
      const text = actions
        .map((action) =>
          action && typeof action === "object"
            ? [action.title, action.value].filter(Boolean).join(" ")
            : action
        )
        .filter(Boolean)
        .join(" ");
      const task = this._content.task ? ` on <strong>${escape(this._content.task)}</strong>` : "";
      return {
        title: `⏰ SLA breached${task}${text ? ": " + escape(text) : "."}`,
        content: "",
      };
    }

    switch (this.models) {
      case "comments":
        const comment = {
          title: "",
          content: "",
        };
        if ("new" == this.message.activityType) {
          comment.title = `<strong>${this._content.owner}</strong> created a comment in the <strong>${this._content.task}</strong> task.`;
          comment.content = this._content.content;
        } else {
          comment.title = `<strong>${this._content.owner}</strong> updated a comment in the <strong>${this._content.task}</strong> task.`;
          comment.content = this._content.content;
        }
        return comment;
      case "tasks":
        const task = {
          title: "",
          content: "",
        };
        if ("new" == this.message.activityType) {
          task.title = `<strong>${this._content.owner}</strong> created new task <strong>${this._content.task}</strong>.`;
          task.content = this._content.task;
        } else {
          task.title = `<strong>${this._content.owner}</strong> updated task <strong>${this._content.task}</strong> task.`;
          const actions = this._content.actions.reduce((acc, action) => {
            if (action.title)
              acc = acc + `<li>${action.title} ${action.value}</li>`;
            else acc = acc + action;

            return acc;
          }, "");
          task.content = `<ul style="list-style-type: none;">${actions}</ul>`;
        }
        return task;

      case "files":
        const file = {
          title: "",
          content: "",
        };
        if ("new" == this.message.activityType) {
          const taskAdd = this._content.task
            ? `in <strong>${this._content.task}</strong> task.`
            : `in <strong>${this._content.project}</strong> project.`;
          file.title = `<strong>${this.parseOwner}</strong> created <strong>${this._content.file}</strong> file ${taskAdd}`;
          file.content = "";
        } else {
          task.title = `<strong>${this.parseOwner}</strong> updated the <strong>${this._content.task}</strong> task.`;
          const actions = this._content.actions.reduce((acc, action) => {
            if (action.title)
              acc = acc + `<li>${action.title} ${action.value}</li>`;
            else acc = acc + action;

            return acc;
          }, "");
          task.content = `<ul style="list-style-type: none;">${actions}</ul>`;
        }
        return file;

      case "steps":
        const step = {
          title: "",
          content: "",
        };
        if ("new" == this.message.activityType) {
          step.title = `<strong>${this._content.owner}</strong> created new step <strong>${this._content.step}</strong>.`;
          step.content = "";
        } else {
          // console.log(this.message)
          // step.title = `<strong>${this._content.owner}</strong> updated a step <strong>${this._content.task}</strong> to <strong>${this._content.task}</strong>.`
          // step.content = this._content.content
        }
        return step;

      default:
        return {
          title: "",
          content: "",
        };
    }
  }
}

export class LogTimer {
  diff(hours = true) {
    const timing = parseInt(this.timeSpend / 60);
    if (hours) return timing;
    else return parseInt(this.timeSpend - timing * 60);
  }

  fullTime() {
    const hours = parseInt(this.timeSpend / 60);
    const minutes = parseInt(this.timeSpend - hours * 60);
    const seconds = this.timeSpend % 60;

    return `${hours > 9 ? hours : "0" + hours}h${
      minutes > 9 ? minutes : "0" + minutes
    }m${seconds > 9 ? seconds : "0" + seconds}s`;
  }

  constructor(timer) {
    this.moment = moment(`${timer.date} ${timer.startTime}`).add(
      timer.timeSpend,
      "secondes"
    );
    (this.exitDateTime = timer.exitDateTime), (this.isClose = timer.isClose);
    this.top = timer.top;
    this.isRunning = timer.isRunning ? true : false;
    this.left = timer.left;
    this.id = timer.id;
    this.client = timer.client;
    this.createdAt = timer.createdAt;
    this.updatedAt = timer.updatedAt;
    this.description = timer.description;
    this.user = timer.user;
    this.timeSpend = timer.timeSpend;
    this.startedAt = timer.date;
    this.startedTime = timer.startTime;
    this.hours = this.diff();
    this.minutes = this.diff(false);
    this.seconds =
      parseInt(this.timeSpend) - (this.hours * 3600 + this.minutes * 60);
    this.fullTime = this.fullTime();
    this.project = timer.project;
    this.tags = timer.tags;
    this.newTags = timer.tags;
    this.taskID = timer.taskID;
    this.stepID = timer.stepID;

    // `timer.task` can be null when the linked task was soft-deleted. Keep the
    // log usable (duration, description, author) instead of throwing.
    this.task = {
      id: timer.task ? timer.task.id : timer.taskID,
      title: timer.task ? timer.task.title : null,
      stepID: timer.stepID,
      // spentTime: timer.task.attributes.spent_time,
    };
  }
}

export class Task {
  #generalSettings = null;
  #requests = null;
  #original_title;

  constructor(params) {
    this.#requests = params.requestSettings;
    this.#original_title = params.title;
    this.task_form_data = params.task_form_data
      ? (async () => {
          if (!params.task_form_data) return null;

          // Handle double-encoded JSON (string containing JSON string)
          let parsed = JSON.parse(params.task_form_data);
          // If result is still a string, parse again
          const json = typeof parsed === 'string' ? JSON.parse(parsed) : parsed;

          // Normalize a JSON:API file resource into the shape file-grid expects
          const normalizeFile = (element) => {
            const { id, attributes, relationships } = element;
            const { users, file_comments } = relationships ?? {};
            return {
              ...attributes,
              id,
              comments: file_comments?.data ?? [],
              tags: (relationships?.tags?.data ?? []).map((tag) => ({
                id: tag.id,
                ...tag.attributes,
              })),
              owner: users?.data
                ? { id: users.data.id, ...users.data.attributes }
                : null,
            };
          };

          const fetchFileById = async (fileId) => {
            try {
              const { data } = await axiosGet(`${BASE_TASK}/files/${fileId}`);
              return data?.data ? normalizeFile(data.data) : null;
            } catch (e) {
              return null;
            }
          };

          return {
            form: await Promise.all(
              json.form.map(async (fo) => {
                if (!fo.isFile) return fo;

                // New shape: explicit list of file IDs
                if (Array.isArray(fo.file_ids)) {
                  const files = await Promise.all(fo.file_ids.map(fetchFileById));
                  return { ...fo, files: files.filter(Boolean) };
                }

                // Fallback: legacy single-id fetch (old broken shape or single-file field)
                const file = await fetchFileById(fo.id);
                return { ...fo, files: file ? [file] : [] };
              })
            ),
          };
        })()
      : null;

    this.request_data = params.request_data
      ? (async () => {
          const incomingRequest = JSON.parse(params.request_data);
          const rawCategory = params.requestSettings?.categories?.find(
            (cat) => parseInt(cat.id) === parseInt(incomingRequest.category)
          );

          const rawSubcategory = rawCategory?.subcategories.find(
            ({ db_id }) => db_id === incomingRequest.subcategory
          );

          return {
            category: rawCategory?.category,
            task_user_id: rawCategory?.task_user_id,
            category_id: rawCategory?.id,
            subcategory: rawSubcategory?.subcategory,
            subcategory_id: rawSubcategory?.db_id ?? rawSubcategory?.id,

            form: await Promise.all(
              incomingRequest.form.map(async (fo) => {
                let rawForm = rawSubcategory?.form.find(
                  (rawFo) => rawFo.id === fo.id
                );

                if (!rawForm && fo.file_id) {
                  rawForm = {
                    id: fo.id,
                    label: "",
                    type: "file",
                    isFile: true,
                  };
                }

                return rawForm
                  ? {
                      ...fo,
                      id: rawForm.id,
                      label: rawForm.label,
                      type: rawForm.type,
                      isFile: rawForm.isFile,
                      files: rawForm.isFile
                        ? await axiosGet(
                            `${BASE_TASK}/files/${fo.file_id}`
                          ).then(
                            ({ data }) => {
                              let _data = [];

                              if (
                                !Array.isArray(data.data) &&
                                data.data !== null
                              ) {
                                const { id, attributes, relationships } =
                                  data.data;
                                const { users, file_comments } = relationships;

                                _data.push({
                                  ...attributes,
                                  id,
                                  comments: file_comments.data,
                                  tags: relationships.tags.data.map((tag) => {
                                    return {
                                      id: tag.id,
                                      ...tag.attributes,
                                    };
                                  }),
                                  owner: {
                                    id: users.data.id,
                                    ...users.data.attributes,
                                  },
                                });
                              } else {
                                data.data.forEach((element) => {
                                  const { id, attributes, relationships } =
                                    element;
                                  const { users, file_comments } =
                                    relationships;

                                  _data.push({
                                    ...attributes,
                                    id,
                                    comments: file_comments.data,
                                    tags: relationships.tags.data.map((tag) => {
                                      return {
                                        id: tag.id,
                                        ...tag.attributes,
                                      };
                                    }),
                                    owner: {
                                      id: users.data.id,
                                      ...users.data.attributes,
                                    },
                                  });
                                });
                              }

                              return _data;
                            },
                            (err) => err
                          )
                        : null,
                    }
                  : {
                      // The field was removed from the subcategory form after this
                      // request was submitted: keep the stored value renderable
                      // instead of yielding `undefined` and crashing taskDetails.
                      ...fo,
                      label: fo.label ?? "Removed field",
                      type: fo.type ?? "text",
                      isFile: !!fo.file_id,
                      files: [],
                    };
              })
            ),
          };
        })()
      : null;

    this.progress = Math.ceil(
      ((params.subtasks_number - params.incomplete_subtasks_number) /
        (params.subtasks_number ? params.subtasks_number : 1)) *
        100
    );

    this.isRequest = params.is_request;
    this.isForm = params.is_form;

    this.position = params.position;
    this.created_at = moment(params.created_at).format("MMMM Do YYYY, h:mm:ss");
    this.created_at_ = params.created_at;
    this.updated_at = params.updated_at;
    this.started_at = params.started_at;
    this.project_name = params.project_name;
    (this.master_id = params.master_id),
      (this.started_at_clone = params.started_at);
    this.has_notification = params.has_notification;
    // Unread reply written by a customer: drives the Support Desk highlight
    this.has_client_reply = !!params.has_client_reply;

    this.archivers = params.archivers;
    this.master = params.master;
    this.loading = false;
    this.files_number = params.files_number;
    // this.request_data = params.request_data;
    this.request_status = params.column != null ? params.column.name : null;
    this.cron_expression = params.cron_expression;

    this.added = params.added;

    this.ticket = params.ticket_;

    this.request_category =
      params.request_data != null
        ? params.requestSettings?.categories?.find(
            (cat) =>
              parseInt(cat.id) ===
              parseInt(JSON.parse(params.request_data).category)
          )?.category
        : null;
    this.request_subcategory =
      params.request_data != null
        ? params.requestSettings?.categories
            ?.find(
              (cat) =>
                parseInt(cat.id) ===
                parseInt(JSON.parse(params.request_data).category)
            )
            ?.subcategories.find(
              (subcat) =>
                parseInt(subcat.db_id) ===
                parseInt(JSON.parse(params.request_data).subcategory)
            )?.subcategory
        : null;

    this.request_issuer =
      params.request_data != null ? params.clients[0].account : null;
    this.comments_number = params.comments_number;
    this.notes_number = params.notes_number;
    this.subtasks_number = params.subtasks_number;
    this.incomplete_subtasks_number = params.incomplete_subtasks_number;
    this.completed_subtasks_number =
      params.subtasks_number - params.incomplete_subtasks_number;
    this.description = params.description;
    this.column = params.column;
    this.approval_stage = params.approval_stage;
    this.title = params.title;
    this.task_system_id = params.task_system_id;
    this.due_date = params.due_date;
    this.due_date_clone = params.due_date;
    this.step_id = params.step_id;
    this.projectId = params.projectId;
    this.next_step_id = params.step_id;
    this.ticket_number = params.ticket_number;
    this.#generalSettings = params.generalSettings;
    this.owner = params.owner;
    this.is_follow = params.is_follow;
    this.is_completed = params.is_completed;
    this.isClosed = params.is_closed;
    this.id = params.id;
    this.priority = params.priority;
    this.estimated_time = params.estimated_time;

    this.assignees = params.assignees;
    this.slaves = params.slaves;

    this.clients = params.clients;
    this.put_to_step = params.put_to_step;
    this.tags = params.tags;
    this.spentTime = params.spentTime;
    this.spentTimeInStep = this.parseTime(params.put_to_step);
    this.client_user = params.client_user;
    this.hasOld = params.due_date
      ? moment(params.due_date) > moment()
        ? false
        : true
      : false;

    // Initialize notes - handle both string (legacy) and array/object (new format)
    if (typeof params.notes === 'string') {
      this.notes = params.notes;
    } else if (Array.isArray(params.notes)) {
      // If notes is an array, we keep it as is for the new multi-note system
      this.notes = params.notes;
    } else if (params.notes && typeof params.notes === 'object') {
      // If notes is an object (shouldn't happen, but handle it gracefully)
      console.warn('Notes received as object, converting to empty string:', params.notes);
      this.notes = "";
    } else {
      this.notes = "";
    }
    this.notesHistory = [];
    
    // Initialize latest feedback
    this.latest_feedback = params.latest_feedback || null;

    this.onParseTitle()
  }

  get original_title() {
    return this.#original_title;
  }

  parseTime(time) {
    if (time) {
      const timing = moment(time).tz(moment.tz.guess()).fromNow();
      return timing == "a few seconds ago"
        ? "Just few seconds ago"
        : `since ${timing}`;
    }
    return null;
  }
  getters(property) {
    return this[`#${property}`];
  }

  updateTask(property, new_value) {
    switch (property) {
      case "title":
        // Update the original title
        this.#original_title = new_value;
        // Set rawTitle to the new value for nomenclature parsing
        this.rawTitle = new_value;
        // Regenerate the formatted title based on nomenclature
        this.onParseTitle();

        break;

      case "request_data":
        if (new_value) {
          if (new_value instanceof Promise) {
            new_value.then((v) => {
              this.request_data = v;
              this.request_category = v.category;
            });
          } else {
            this.request_data = new_value;
          }
        } else this.request_data = null;

        break;

      case "subtask_compled":
        this.incomplete_subtasks_number = new_value
          ? this.incomplete_subtasks_number - 1
          : this.incomplete_subtasks_number + 1;
        this.completed_subtasks_number =
          this.subtasks_number - this.incomplete_subtasks_number;
        this.progress = Math.ceil(
          ((this.subtasks_number - this.incomplete_subtasks_number) /
            (this.subtasks_number ? this.subtasks_number : 1)) *
            100
        );

        break;

      case "closed_at":
        this.due_date = new_value;
        this[property] = new_value;
        break;

      case "notes":
        // Update the notes content
        this.notes = new_value;
        
        // Add to notes history for real-time tracking
        if (new_value) {
          this.notesHistory.push({
            content: new_value,
            timestamp: new Date().toISOString(),
            action: 'updated'
          });
        }
        break;

      default:
        this[property] = new_value;
        break;
    }

    return this;
  }

  appendNote(noteData) {
    // Append a new note to the notes history
    if (noteData) {
      const noteEntry = {
        id: noteData.id,
        content: noteData.content,
        user: noteData.user,
        timestamp: noteData.created_at || new Date().toISOString(),
        action: 'created'
      };
      
      this.notesHistory.push(noteEntry);
      
      // Update the main notes field with the latest content
      this.notes = noteData.content;
    }
    
    return this;
  }

  async resolveAll() {
    let promises = [this.task_form_data, this.request_data];

    Promise.all(promises)
      .then(([form, request]) => {
        if (form) this.task_form_data = form;

        if (request) {
          this.request_data = {
            ...request,
            form: request.form.filter((fo) => !!fo),
          };
        }

        this.onParseTitle();

        return {
          task_form_data: this.task_form_data,
          request_data: this.task_form_data,
        };
      })
      .catch((e) => console.log(e));
  }


  onParseTitle() {
    if (
      this.#generalSettings?.hasOwnProperty("task attributes") &&
      !this.task_system_id
    ) {
      const inputTemplate = this.#generalSettings["task attributes"].content;
      if (!inputTemplate) {
        // If no template, just use the original title as is
        this.title = this.#original_title;
        return this.title;
      }

      // Use original_title as the base for parsing
      const baseTitle = this.#original_title || this.title || "";
      
      const categoryId = parseInt(this.ticket?.category);
      const subcategoryId = parseInt(this.ticket?.subcategory);

      const categoryObj = this.#requests?.categories.find(
        (cat) => parseInt(cat.id) === categoryId
      );

      const ticket = {
        category: !this.ticket?.category
          ? null
          : this.#requests?.categories.find(
              (cat) => parseInt(cat.id) === parseInt(this.ticket?.category)
            )?.category,
        subcategory: !this.ticket?.subcategory
          ? null
          : this.#requests?.categories
              .find(
                (cat) => parseInt(cat.id) === parseInt(this.ticket?.category)
              )
              ?.subcategories.find(
                (subcat) =>
                  parseInt(subcat.db_id) === parseInt(this.ticket?.subcategory)
              )?.subcategory,
      };

      const client = this.clients[0] ?? {};

      // Use ticket data (from task's own request_data) as primary source,
      // fall back to client data for backward compatibility with older tasks
      const locationId = this.ticket?.locationId ?? client.locationId ?? "";
      const account = this.ticket?.sub_account_name || client?.sub_account_name || client?.account || "";

      const replacements = {
        "task.title": baseTitle,
        "task.request_data.category": ticket.category ?? "",
        "task.request_data.subcategory": ticket.subcategory ?? "",
        "task.request.locationId": locationId,
        "task.request.sub_account_name": account,
        "task.ticket_number": this.ticket_number ?? "",
        "task.approval_stage": this.approval_stage ?? "",
      };

      let title = inputTemplate.replace(/{{|}}/g, "");
      for (const [key, value] of Object.entries(replacements)) {
        title = title.replace(new RegExp(key, "g"), value);
      }

      this.title = title;
    } else {
      // If no formatting needed, just use original title
      this.title = this.#original_title;
    }
  }


  replaceTask(task) {
    for (let tk in task) {
      this.updateTask(tk, task[tk]);
    }
  }

  deleteTask() {}

  clone() {
    return JSON.parse(
      JSON.stringify({ ...this, original_title: this.#original_title })
    );
  }

  addComment(comment) {}

  removeComment(commentID) {}

  startLoading(status) {
    if (status instanceof Boolean)
      throw new Error(`${status} should be a boolean`);
    this.loading = status;
  }
}

export class Step {
  constructor(params) {
    this.id = params.id;
    this.project_id = params.project_id;
    this.ids = params.ids;
    this.total = params.total;
    this.visible = params.visible ? params.visible : true;
    this.createdAt = params.created_at ? params.created_at : params.createdAt;
    this.updatedAt = params.updated_at ? params.updated_at : params.updatedAt;
    this.tasks = params.tasks;
    this.name = params.name;
    this.color = params.color;
    this.position = params.position;
    this.encryptId = params.encryptId || null;

    this.index = params.index;
    this.page = params.page ? params.page : 1;
    this.canLoad = params.canLoad ? params.canLoad : true;
    this.isLoading = params.isLoading ? params.isLoading : false;
  }

  loading(status) {
    if ("boolean" === typeof status)
      throw new Error(`${status} should be a boolean`);
    this.isLoading = status;
  }

  updateProperty(property, new_value) {
    this[property] = new_value;
  }

  addTasks(tasks, page, canBeLoad, paginate) {
    if (Array.isArray(tasks)) {
      this.tasks = [...this.tasks, ...tasks];
      // this.total = this.total + tasks.length
    } else {
      this.tasks = [...this.tasks, tasks];
      // this.total = this.total + 1
    }

    this.page = Math.ceil(this.tasks.length / paginate);
    this.canLoad = canBeLoad;
  }

  addTask(
    task,
    position = "push",
    index = null,
    replace = false,
    updateTotal = false
  ) {
    if (updateTotal) this.total = this.total + 1;

    if (task instanceof Task) {

      if (replace) {
        this.tasks[index] = task;
      } else {
        const existingIndex = this.tasks.findIndex((t) => t.id === task.id);
        if (existingIndex !== -1) {
          this.tasks[existingIndex] = task;
        } else {
          this.tasks[position](task);
        }
      }
    } else if (task instanceof Object) {
      const newTask = task;
      const existingIndex = this.tasks.findIndex((t) => t.id === newTask.id);

      if (existingIndex !== -1) {
        this.tasks[existingIndex] = new Task(newTask);
      } else {
        if (replace) {
          this.tasks[index] = new Task(newTask);
        } else {
          if (index) this.tasks.splice(index, 0, new Task(newTask));
          else this.tasks[position](new Task(newTask));
        }
        // newTask.resolveAll();
      }
    }
  }

  clearTask(callback = null) {
    if (callback) {
      const newTasks = this.tasks.filter(callback);
      this.tasks = newTasks;
      this.total = newTasks.length;
    } else {
      this.tasks = [];
      this.total = 0;
    }
  }

  removeTask(task_id) {
    this.tasks = this.tasks.filter(({ id }) => id !== task_id);
    this.total = this.total ? this.total - 1 : 0;
  }

  sortTask(criteria) {
    if (criteria)
      this.tasks = SortedMixins.methods.sorting(criteria, this.tasks);
  }

  positionSort() {
    return this.tasks.sort((a, b) => a.position - b.position);
  }

  updateStep() {}
}

export class Trigger {
  constructor(params) {
    this.createdAt = params.created_at;
    this.updatedAt = params.updated_at;
    this.title = params.title;
    this.status = params.status;
    this.isRunning = params.status == "running" ? true : false;
    this.triggerName = params.triggerName;
    this.id = params.id;
    this.options = params.options;
    this.triggerID = params.triggerID;
    this.tags = params.tags ? params.tags.split(",") : [];
    this.fieldID = params.custom_field_id;
    this.default = params.default ? true : false;
    this.taskTagIds = this.parseTaskTagIds(params.task_tag_ids);
    this.moveToStepId = params.move_to_step_id ? Number(params.move_to_step_id) : null;
    // null = leave as is, 1 = mark complete, 0 = mark incomplete (0 is a real value here)
    this.setCompleted = (params.set_completed === null || params.set_completed === undefined) ? null : Number(params.set_completed);
    // reply snippet posted on the card as an external comment, null = none
    this.replySnippetId = params.reply_snippet_id ? Number(params.reply_snippet_id) : null;
    this.parseContacts(params.contacts);
  }

  // JSON string like contacts: project_tags ids to put on the task card
  parseTaskTagIds(data) {
    try { return [].concat(JSON.parse(data) || []); } catch (e) { return []; }
  }

  parseContacts(data) {
    if (!data) return [];

    const contacts = JSON.parse(data);

    this.type = contacts.type ? contacts.type : null;
    this.email = contacts.email ? contacts.email : "";
  }
}

export class TaskForm {
  constructor(params) {
    this.createdAt = params.attributes.created_at;
    this.updatedAt = params.attributes.updated_at;
    this.projectID = params.attributes.project_id;
    this.stepID = params.attributes.step_id;
    this.userID = params.attributes.task_user_id;
    this.button = params.attributes.button;
    this.form = params.attributes.form;
    this.id = params.id;
    this.css = params.attributes.css;

    this.step = params.attributes.step_id;
    this.name = params.attributes.name;
    this.assignees = params.relationships.assignees.data.map((user) => {
      user.title = user.attributes.first_name;
      return user;
    });
  }
}


export class Template {
  constructor(params) {
    this.createdAt = params.attributes.created_at;
    this.updatedAt = params.attributes.updated_at;
    this.projectID = params.attributes.project_id;
    this.triggerID = params.attributes.trigger_id;
    this.status = params.attributes.is_running ? true : false;
    this.state = params.attributes.is_running ? "running" : "stopped";

    this.notifyClient = params.attributes.is_for_notify_client;

    this.global = params.attributes.is_global ? true : false;

    this.userID = params.attributes.task_user_id;

    this.userID = params.attributes.task_user_id;

    this.who = params.attributes.who;

    this.triggerName = params.relationships.triggers.data.attributes.name;

    this.title = params.attributes.title;

    this.id = params.id;

    this.body = params.attributes.body;

    this.options = params.attributes.filters
      ? JSON.parse(params.attributes.filters)
      : null;
  }
}

export class Snippet {

  transformName(name) {
    this.label = name,
      this.path = name.toLowerCase().trim().replace(/\s+/g, '.')
  }

  constructor(params) {

    this.label = null;
    this.path = null;

    this.createdAt = params.attributes.created_at;
    this.updatedAt = params.attributes.updated_at;
    this.projectID = params.attributes.project_id;
    this.triggerID = params.attributes.trigger_id;

    // 'email' = reusable block for a notification template (bound to a trigger)
    // 'reply' = canned reply inserted while commenting, no trigger
    this.snippetType = params.attributes.snippet_type || "email";
    this.isReply = this.snippetType === "reply";

    this.title = params.attributes.title;
    this.body = params.attributes.body;

    this.status = params.attributes.is_running ? true : false;
    this.state = params.attributes.is_running ? "running" : "stopped";

    // Reply snippets have no trigger, so the API serialises the relationship as
    // an empty array. Guard against it: reading .attributes on [] threw here and
    // took down the whole snippet list.
    const triggerData = params.relationships?.triggers?.data;
    this.triggerName = Array.isArray(triggerData)
      ? null
      : triggerData?.attributes?.name ?? null;

    this.id = params.id;

    this.transformName(this.title)


  }
}


export class Queue {
  constructor(elements = []) {
    this.queue = elements;
  }
  enqueue(element) {
    const data = Array.isArray(element) ? [...element] : [element];
    return this.queue.push(data);
  }

  dequeue() {
    if (this.queue.length > 0) {
      return this.queue.shift(); // remove first element
    }
  }

  isEmpty() {
    return this.queue.length == 0;
  }
}
